// Codekit -->

// Global -->
// @codekit-prepend "global/vars.js"

// Utilities -->
// @codekit-prepend "utilities/debounce.js"
// @codekit-prepend "utilities/load-in.js"
// @codekit-prepend "utilities/ajax.js"
// @codekit-prepend "utilities/image-viewer.js"
// @codekit-prepend "utilities/scroll.js"
// @codekit-prepend "utilities/full-height.js"

// Components -->
// @codekit-prepend "components/menu.js"
// @codekit-prepend "components/menu-overlay.js"
// @codekit-prepend "components/menu-overlay-links.js"
// @codekit-prepend "components/hero-nav.js"
// @codekit-prepend "components/link-circle.js"
// @codekit-prepend "components/chapter-slider.js"
// @codekit-prepend "components/co2-chapter.js"
// @codekit-prepend "components/waste-chapter.js"
// @codekit-prepend "components/stage-chapter.js"
// @codekit-prepend "components/contact-form.js"


// Resize -->
// @codekit-append "global/document-ready.js"
// @codekit-append "global/resize.js"

//<- Codekit

//Funcitons start -->

//load in
loadIn();

//Menu
// menu();

//Header
// window.addEventListener("scroll", debounce(headerReveal));

//Example function pullin
// if (typeof hero != "undefined" && hero != null) {
//     heroSize();
// }

if (typeof fullHeightEls != "undefined" && fullHeightEls != null) {
    makeFullHeight();
}

if (typeof scrollButton != "undefined" && scrollButton != null) {
    scrollToTarget(scrollButton, scrollTarget, 0)
}

//<-- Funcitons end
